__turbopack_context__.v({
  "cat": "TeamNews-module-scss-module__NJI3kW__cat",
  "catActive": "TeamNews-module-scss-module__NJI3kW__catActive",
  "catRow": "TeamNews-module-scss-module__NJI3kW__catRow",
  "empty": "TeamNews-module-scss-module__NJI3kW__empty",
  "grid": "TeamNews-module-scss-module__NJI3kW__grid",
  "showAll": "TeamNews-module-scss-module__NJI3kW__showAll",
  "unreadBadge": "TeamNews-module-scss-module__NJI3kW__unreadBadge",
});
